// Components
import { Link } from '@tracklib/kit'

// Types
import { Label } from 'types'

// Utils
import styles from './infoitem2.css'

type LabelsProps = {
  labels: Array<Label>
  showAll?: boolean
  displayAsRow?: boolean
  isModal: boolean
  modalOpen?: boolean
  toggleModalOpen?: (open?: boolean) => void
}

const Labels = ({ labels, showAll, displayAsRow, modalOpen, isModal, toggleModalOpen }: LabelsProps): JSX.Element => {
  const firstLabel = labels[0]
  const labelsLength = labels.length

  if (showAll || isModal) {
    return (
      <>
        {labels.map<Label>((label, i) => (
          <span key={label.id}>
            <Link to={`/label/${label.slug}`}>{label.name}</Link>
            {showAll && displayAsRow && labelsLength !== i + 1 && <span>&#44;&nbsp;</span>}
          </span>
        ))}
      </>
    )
  }

  return (
    <span>
      <Link to={`/label/${firstLabel.slug}/`}>{firstLabel.name}</Link>
      {labelsLength > 1 && (
        <>
          <span className={styles.plus}>&nbsp;+&nbsp;</span>
          <Link onClick={(): void => toggleModalOpen && toggleModalOpen(!modalOpen)}>{labelsLength - 1} more</Link>
        </>
      )}
    </span>
  )
}

export default Labels
